import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// 'forms', or wherever you export redux-form's formValueSelector from
import { getFormMeta } from './index'
import _ from 'lodash'

/*
  Usage:

  Same as <FormValueSelector>,
  The only different is that <FormMetaSelector> using `getFormMeta()` of redux-form
*/

@connect((state, props) => {
  const {
    form, withoutPrefix, sectionPrefix, fieldName, selector
  } = props

  const formMeta = getFormMeta(form)(state)
  const getMetaByFieldName = name => _.get(formMeta, name)

  if (_.isFunction(selector)) {
    return ({
      values: selector(
        getMetaByFieldName,
        form,
        sectionPrefix,
        form in state.form
          ? state.form[form].values
          : {}
      )
    })
  }

  const fullFieldName = (sectionPrefix && !withoutPrefix)
    ? `${sectionPrefix}.${fieldName}`
    : fieldName

  return ({
    values: getMetaByFieldName(fullFieldName)
  })
})
class FormMetaSelector extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    values: PropTypes.any
  }

  render () {
    const { children, values = {} } = this.props

    return children(values) || null
  }
}

export default function FormMetaSelectorContextContainer (props, context) {
  const { _reduxForm } = context
  return (
    <FormMetaSelector
      {...props}
      form={props.form || _reduxForm.form}
      sectionPrefix={props.sectionPrefix || _reduxForm.sectionPrefix}
    />
  )
}

FormMetaSelectorContextContainer.propTypes = {
  form: PropTypes.string,
  withoutPrefix: PropTypes.bool,
  sectionPrefix: PropTypes.string
}

FormMetaSelectorContextContainer.contextTypes = {
  _reduxForm: PropTypes.shape({
    form: PropTypes.string.isRequired,
    sectionPrefix: PropTypes.string
  }).isRequired
}
